import { render, staticRenderFns } from "./WarningSection.vue?vue&type=template&id=04e5b2e2&scoped=true&"
import script from "./WarningSection.vue?vue&type=script&lang=js&"
export * from "./WarningSection.vue?vue&type=script&lang=js&"
import style0 from "./WarningSection.vue?vue&type=style&index=0&id=04e5b2e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e5b2e2",
  null
  
)

export default component.exports